import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    TASK_EQUIPMENT_LIST_DELIVERY_PLAN,
    EQUIPMENT_MODEL_UPDATE,
    EQUIPMENT_UNIT_UPDATE,
    EQUIPMENT_BULK_SAVE
} from '../actions';
import {
    TaskEquipmentListDeliveryPlanSuccess,
    TaskEquipmentListDeliveryPlanError,
    EquipmentModelUpdateSuccess,
    EquipmentModelUpdateError,
    EquipmentUnitUpdateSuccess,
    EquipmentUnitUpdateError,
    EquipmentBulkSaveSuccess,
    EquipmentBulkSaveError
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

// LIST DELIVERY PLAN
const onTaskEquipmentListDeliveryPlanAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task-equipment/delivery-plan/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskEquipmentListDeliveryPlan(action) {
    try {
        const response = yield call(onTaskEquipmentListDeliveryPlanAsync, action.payload);
        yield put(TaskEquipmentListDeliveryPlanSuccess(response.data.data));
    } catch (error) {
        console.log('[saga task_equipment] error:', error);
        yield put(TaskEquipmentListDeliveryPlanError(error));
    }
}

function* watchTaskEquipmentListDeliveryPlan() { yield takeEvery(TASK_EQUIPMENT_LIST_DELIVERY_PLAN, onTaskEquipmentListDeliveryPlan); }

// EQUIPMENT MODEL UPDATE (legacy onBlur - kept for compatibility)
const onEquipmentModelUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'equipment_model/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log('[saga] EquipmentModelUpdate fetch error:', err));
    return { data: response };
};

function* onEquipmentModelUpdate(action) {
    try {
        const response = yield call(onEquipmentModelUpdateAsync, action.payload);
        yield put(EquipmentModelUpdateSuccess(response.data));
    } catch (error) {
        yield put(EquipmentModelUpdateError(error));
    }
}

function* watchEquipmentModelUpdate() { yield takeEvery(EQUIPMENT_MODEL_UPDATE, onEquipmentModelUpdate); }

// EQUIPMENT UNIT UPDATE (legacy onBlur - kept for compatibility)
const onEquipmentUnitUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'equipment-unit/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log('[saga] EquipmentUnitUpdate fetch error:', err));
    return { data: response };
};

function* onEquipmentUnitUpdate(action) {
    try {
        const response = yield call(onEquipmentUnitUpdateAsync, action.payload);
        yield put(EquipmentUnitUpdateSuccess(response.data));
    } catch (error) {
        yield put(EquipmentUnitUpdateError(error));
    }
}

function* watchEquipmentUnitUpdate() { yield takeEvery(EQUIPMENT_UNIT_UPDATE, onEquipmentUnitUpdate); }

// BULK SAVE (models + units in one action)
const onBulkSaveModelsAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'equipment_model/bulk-update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

const onBulkSaveUnitsAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'equipment-unit/bulk-update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onEquipmentBulkSave(action) {
    try {
        const { models, units } = action.payload;
        let success = true;

        if (models && models.length > 0) {
            const responseModels = yield call(onBulkSaveModelsAsync, { models });
            if (!responseModels.data || responseModels.data.status !== true) success = false;
        }

        if (units && units.length > 0) {
            const responseUnits = yield call(onBulkSaveUnitsAsync, { units });
            if (!responseUnits.data || responseUnits.data.status !== true) success = false;
        }

        if (success) {
            NotificationManager.success('Información guardada con Éxito', 'Éxito', 3000, null, null, '');
            yield put(EquipmentBulkSaveSuccess({ message: 'Éxito' }));
        } else {
            NotificationManager.error('Error al guardar la información', 'Error', 3000, null, null, '');
            yield put(EquipmentBulkSaveError('Error'));
        }
    } catch (error) {
        NotificationManager.error('Error al guardar la información', 'Error', 3000, null, null, '');
        yield put(EquipmentBulkSaveError(error));
    }
}

function* watchEquipmentBulkSave() { yield takeEvery(EQUIPMENT_BULK_SAVE, onEquipmentBulkSave); }

export default function* rootSaga() {
    yield all([
        fork(watchTaskEquipmentListDeliveryPlan),
        fork(watchEquipmentModelUpdate),
        fork(watchEquipmentUnitUpdate),
        fork(watchEquipmentBulkSave)
    ]);
}
